<script setup>
defineProps({
  catalog: { type: Array, required: true }, // [{module, label, actions:[{value,label}]}]
  permissions: { type: Object, required: true }, // { 'module:action': bool }
  readonly: { type: Boolean, default: false },
});
defineEmits(['toggle']);
</script>

<template>
  <div class="employee-permission-matrix">
    <div v-for="mod in catalog" :key="mod.module" class="permission-module-row">
      <div class="module-label">{{ mod.label }}</div>
      <div class="module-actions">
        <label v-for="action in mod.actions" :key="action.value" class="action-toggle">
          <input type="checkbox" :checked="!!permissions[`${mod.module}:${action.value}`]" :disabled="readonly"
            @change="$emit('toggle', mod.module, action.value)" />
          <span>{{ action.label }}</span>
        </label>
      </div>
    </div>
    <p v-if="!catalog.length" class="empty">Catálogo de permisos no disponible.</p>
  </div>
</template>

<style lang="scss" scoped>
.employee-permission-matrix {
  display: flex;
  flex-direction: column;
}

.permission-module-row {
  align-items: flex-start;
  border-bottom: 1px solid #edf0f7;
  display: grid;
  gap: 10px 18px;
  grid-template-columns: 190px minmax(0, 1fr);
  padding: 12px 0;
}

.permission-module-row:last-child {
  border-bottom: 0;
}

.module-label {
  color: #30385d;
  font-size: .92rem;
  font-weight: 800;
}

.module-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 22px;
}

.action-toggle {
  align-items: center;
  color: #474ce6;
  cursor: pointer;
  display: inline-flex;
  font-size: .85rem;
  font-weight: 600;
  gap: 7px;
}

.action-toggle input {
  accent-color: #474ce6;
  cursor: pointer;
  height: 16px;
  width: 16px;
}

.empty {
  color: #7c83a2;
  padding: 12px 0;
}

@media(max-width:767px) {
  .permission-module-row {
    grid-template-columns: 1fr;
  }
}
</style>
